import { HttpParams } from '@angular/common/http';
import { forwardRef, Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DATA_SHARING_TOKENS, USER_ME_DATA_SHARING_TOKENS } from '../common/endpoints';
import { DataSharingToken, PagedList } from '../model';
import { HttpService } from './http.service';

@Injectable()
export class DataSharingTokenService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService
    ) { }

    getDataSharingTokens(page: number, size: number, sort: string[], searchText: string): Promise<PagedList<DataSharingToken>> {
        let params = new HttpParams();
        params = params.set('page', page + '');
        params = params.set('size', size + '');
        if (sort && sort[0]) {
            params = params.set('sort', sort[0] + ',' + sort[1]);
        }
        if (searchText) {
            params = params.set('searchText', `*${searchText}*`);
        }
        return firstValueFrom(this.httpService.get<PagedList<DataSharingToken>>(USER_ME_DATA_SHARING_TOKENS, params));
    }


    save(body: any): Promise<DataSharingToken> {
        return firstValueFrom(this.httpService.post<DataSharingToken>(DATA_SHARING_TOKENS, body));
    }

    accept(code: string): Promise<void> {
        const params = new HttpParams().set('code', code);
        return firstValueFrom(this.httpService.post<void>(DATA_SHARING_TOKENS + '/accept', {}, params));
    }

}